export default "__VITE_ASSET__c8b2dd1f__"